import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create DeleteVariation action
 */
export function createAddComment(store: Store, _storeActions: StoreActions): ContextMenu.Action {
  return {
    getDisplayName: ({ node }) => {
      if (node.ids.move > 0) {
        return MoveList.Translation.Actions.InsertComment;
      } else {
        return MoveList.Translation.Actions.InsertCommentAfter;
      }
    },
    action: CONTEXT_MENU_ACTION_NAMES.AddComment,
    isVisible,
    handler,
  };

  /**
   * visible when there is no comment
   */
  function isVisible({ node }) {
    const isEditable = store.commentsEditable.get();

    return node.comment === undefined && isEditable;
  }

  /**
   * handler to add comment after node
   */
  function handler({ node, game }: ContextMenu.ActionHandlerContext): void {
    game.updateNode(node.ids, { comment: '' });
  }
}
